/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component, ChangeDetectionStrategy, EventEmitter, Output,
} from '@angular/core';

@Component({
  selector: 'ut-delete-btn',
  templateUrl: './delete-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeleteBtnComponent {
  @Output() delete = new EventEmitter<void>();

  activated = false;

  onDeleteClick(): void {
    this.activated = true;
  }

  onCancelClick(): void {
    this.activated = false;
  }

  onConfirmClick(): void {
    this.delete.emit();
    this.activated = false;
  }
}
